import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { logOut } from 'actions/authentication';
import { loadProvider, uploadProviderAvatar } from 'actions/provider';
import Button from 'atoms/button';
import Icon from 'atoms/icon';
import ImageUploader from 'atoms/image-uploader';
import { InfoBlock } from 'organisms/InfoBlock';
import { generateKey, prettifyHour, prettifyPhoneNumber } from 'util';

import EditInfoModal from '../modals/EditInfoModal';

export default function ProfileInfoBar({ isMyProvider, provider }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, openModal] = useState(false);
  const { inviteCode, locations, userList, slug } = provider;
  const {
    name,
    email,
    locality,
    postalCode,
    address1,
    region,
    type,
    hours,
    phone,
    links,
  } = locations[0];
  const dowOptions = useSelector((state) => state.main.calendar.dayOfWeek);
  const { isAdmin } = useSelector((state) => state.user);

  const hasUser = userList?.length;

  const onEditInformation = () => {
    openModal(true);
  };

  const editImage = (image) => {
    dispatch(uploadProviderAvatar(image)).then(({ success }) => {
      if (success) {
        dispatch(loadProvider());
      }
    });
  };

  const oncreateTeamUserAccount = () => {
    sessionStorage.setItem('inviteCode', inviteCode);
    sessionStorage.setItem('inviteCodeProvider', slug);
    navigate(`/signup`);
  };

  return (
    <InfoBlock>
      <div className="profile-info">
        <div className="mb-20 ml-35">
          <div className="avatar-section">
            <ImageUploader
              fileName="upload_file"
              showEditIcon={isMyProvider}
              saveImage={editImage}
              avatar={links?.image?.desktop?.small}
              placeholder="pawFilled"
              variant="profile"
            />
          </div>
          <h2>{name}</h2>
          <p className="mb-5">{type.map((el) => el.value).join(', ')}</p>
        </div>
        <div className="profile-info-details mb-25">
          <div>
            {phone && (
              <span className="flex-row mt-15 phone">
                <Icon name="phone" className="mr-15" />
                <p>
                  {prettifyPhoneNumber({
                    number: phone.number,
                    countryCode: phone.country.code.value,
                  })}
                </p>
              </span>
            )}
            {email && (
              <span className="flex-row mt-35 email">
                <Icon name="email" className="mr-15" />
                <p>{email}</p>
              </span>
            )}
            <span className="flex-row mt-35 mb-30 address">
              <Icon name="map-drop" className="mr-25" />
              <span>
                <p>{address1}</p>
                <p>{`${locality}, ${region} ${postalCode}`}</p>
              </span>
            </span>
          </div>
          <span className="flex-row align-start hours">
            <Icon name="clock" className="mr-20" />
            <div className="flex-column">
              {dowOptions.map((el, i) => {
                const filteredData = hours.filter(
                  (hour) => hour.dow.value === el.value
                );
                const hourBlock = filteredData[0];
                return (
                  <div key={generateKey} className="flex-row mb-10">
                    <span className="mr-15 day">
                      {hourBlock ? hourBlock.dow.value : el.value}
                    </span>
                    <span className="w100">
                      {hourBlock
                        ? `${prettifyHour(
                            hourBlock.time.start
                          )} - ${prettifyHour(hourBlock.time.end)}`
                        : 'Closed'}
                    </span>
                  </div>
                );
              })}
            </div>
          </span>
        </div>
        {isMyProvider && (
          <Button
            onClick={onEditInformation}
            size="medium"
            className="ml-35 mb-10"
            variant="reverse"
            text="Edit information"
          />
        )}
        {isAdmin && !hasUser && (
          <Button
            onClick={oncreateTeamUserAccount}
            size="medium"
            className="ml-35 mb-35"
            variant={inviteCode ? 'reverse' : 'reverse-disabled'}
            text={inviteCode ? 'Create user account' : 'No invite code'}
          />
        )}
      </div>
      {isOpen && <EditInfoModal isOpen={isOpen} openModal={openModal} />}
    </InfoBlock>
  );
}
